/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SitesRouteRouteImport } from './routes/sites/route'
import { Route as SiteListsRouteRouteImport } from './routes/site-lists/route'
import { Route as SettingsRouteRouteImport } from './routes/settings/route'
import { Route as ContractsRouteRouteImport } from './routes/contracts/route'
import { Route as BillsRouteRouteImport } from './routes/bills/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SitesIndexRouteImport } from './routes/sites/index'
import { Route as SiteListsIndexRouteImport } from './routes/site-lists/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as ContractsIndexRouteImport } from './routes/contracts/index'
import { Route as BillsIndexRouteImport } from './routes/bills/index'
import { Route as SitesSiteIdRouteImport } from './routes/sites/$siteId'
import { Route as SiteListsSiteListIdRouteImport } from './routes/site-lists/$siteListId'
import { Route as SettingsEmailTemplatesRouteImport } from './routes/settings/email-templates'
import { Route as ContractsMergeProposalsRouteImport } from './routes/contracts/merge-proposals'
import { Route as ContractsContractIdRouteImport } from './routes/contracts/$contractId'
import { Route as BillsBillIdRouteImport } from './routes/bills/$billId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SitesRouteRoute = SitesRouteRouteImport.update({
  id: '/sites',
  path: '/sites',
  getParentRoute: () => rootRouteImport,
} as any)
const SiteListsRouteRoute = SiteListsRouteRouteImport.update({
  id: '/site-lists',
  path: '/site-lists',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRouteRoute = SettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ContractsRouteRoute = ContractsRouteRouteImport.update({
  id: '/contracts',
  path: '/contracts',
  getParentRoute: () => rootRouteImport,
} as any)
const BillsRouteRoute = BillsRouteRouteImport.update({
  id: '/bills',
  path: '/bills',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SitesIndexRoute = SitesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SitesRouteRoute,
} as any)
const SiteListsIndexRoute = SiteListsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SiteListsRouteRoute,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const ContractsIndexRoute = ContractsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ContractsRouteRoute,
} as any)
const BillsIndexRoute = BillsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BillsRouteRoute,
} as any)
const SitesSiteIdRoute = SitesSiteIdRouteImport.update({
  id: '/$siteId',
  path: '/$siteId',
  getParentRoute: () => SitesRouteRoute,
} as any)
const SiteListsSiteListIdRoute = SiteListsSiteListIdRouteImport.update({
  id: '/$siteListId',
  path: '/$siteListId',
  getParentRoute: () => SiteListsRouteRoute,
} as any)
const SettingsEmailTemplatesRoute = SettingsEmailTemplatesRouteImport.update({
  id: '/email-templates',
  path: '/email-templates',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const ContractsMergeProposalsRoute = ContractsMergeProposalsRouteImport.update({
  id: '/merge-proposals',
  path: '/merge-proposals',
  getParentRoute: () => ContractsRouteRoute,
} as any)
const ContractsContractIdRoute = ContractsContractIdRouteImport.update({
  id: '/$contractId',
  path: '/$contractId',
  getParentRoute: () => ContractsRouteRoute,
} as any)
const BillsBillIdRoute = BillsBillIdRouteImport.update({
  id: '/$billId',
  path: '/$billId',
  getParentRoute: () => BillsRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/bills': typeof BillsRouteRouteWithChildren
  '/contracts': typeof ContractsRouteRouteWithChildren
  '/settings': typeof SettingsRouteRouteWithChildren
  '/site-lists': typeof SiteListsRouteRouteWithChildren
  '/sites': typeof SitesRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/bills/$billId': typeof BillsBillIdRoute
  '/contracts/$contractId': typeof ContractsContractIdRoute
  '/contracts/merge-proposals': typeof ContractsMergeProposalsRoute
  '/settings/email-templates': typeof SettingsEmailTemplatesRoute
  '/site-lists/$siteListId': typeof SiteListsSiteListIdRoute
  '/sites/$siteId': typeof SitesSiteIdRoute
  '/bills/': typeof BillsIndexRoute
  '/contracts/': typeof ContractsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/site-lists/': typeof SiteListsIndexRoute
  '/sites/': typeof SitesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/bills/$billId': typeof BillsBillIdRoute
  '/contracts/$contractId': typeof ContractsContractIdRoute
  '/contracts/merge-proposals': typeof ContractsMergeProposalsRoute
  '/settings/email-templates': typeof SettingsEmailTemplatesRoute
  '/site-lists/$siteListId': typeof SiteListsSiteListIdRoute
  '/sites/$siteId': typeof SitesSiteIdRoute
  '/bills': typeof BillsIndexRoute
  '/contracts': typeof ContractsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/site-lists': typeof SiteListsIndexRoute
  '/sites': typeof SitesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/bills': typeof BillsRouteRouteWithChildren
  '/contracts': typeof ContractsRouteRouteWithChildren
  '/settings': typeof SettingsRouteRouteWithChildren
  '/site-lists': typeof SiteListsRouteRouteWithChildren
  '/sites': typeof SitesRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/bills/$billId': typeof BillsBillIdRoute
  '/contracts/$contractId': typeof ContractsContractIdRoute
  '/contracts/merge-proposals': typeof ContractsMergeProposalsRoute
  '/settings/email-templates': typeof SettingsEmailTemplatesRoute
  '/site-lists/$siteListId': typeof SiteListsSiteListIdRoute
  '/sites/$siteId': typeof SitesSiteIdRoute
  '/bills/': typeof BillsIndexRoute
  '/contracts/': typeof ContractsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/site-lists/': typeof SiteListsIndexRoute
  '/sites/': typeof SitesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/bills'
    | '/contracts'
    | '/settings'
    | '/site-lists'
    | '/sites'
    | '/login'
    | '/bills/$billId'
    | '/contracts/$contractId'
    | '/contracts/merge-proposals'
    | '/settings/email-templates'
    | '/site-lists/$siteListId'
    | '/sites/$siteId'
    | '/bills/'
    | '/contracts/'
    | '/settings/'
    | '/site-lists/'
    | '/sites/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/bills/$billId'
    | '/contracts/$contractId'
    | '/contracts/merge-proposals'
    | '/settings/email-templates'
    | '/site-lists/$siteListId'
    | '/sites/$siteId'
    | '/bills'
    | '/contracts'
    | '/settings'
    | '/site-lists'
    | '/sites'
  id:
    | '__root__'
    | '/'
    | '/bills'
    | '/contracts'
    | '/settings'
    | '/site-lists'
    | '/sites'
    | '/login'
    | '/bills/$billId'
    | '/contracts/$contractId'
    | '/contracts/merge-proposals'
    | '/settings/email-templates'
    | '/site-lists/$siteListId'
    | '/sites/$siteId'
    | '/bills/'
    | '/contracts/'
    | '/settings/'
    | '/site-lists/'
    | '/sites/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BillsRouteRoute: typeof BillsRouteRouteWithChildren
  ContractsRouteRoute: typeof ContractsRouteRouteWithChildren
  SettingsRouteRoute: typeof SettingsRouteRouteWithChildren
  SiteListsRouteRoute: typeof SiteListsRouteRouteWithChildren
  SitesRouteRoute: typeof SitesRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sites': {
      id: '/sites'
      path: '/sites'
      fullPath: '/sites'
      preLoaderRoute: typeof SitesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/site-lists': {
      id: '/site-lists'
      path: '/site-lists'
      fullPath: '/site-lists'
      preLoaderRoute: typeof SiteListsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contracts': {
      id: '/contracts'
      path: '/contracts'
      fullPath: '/contracts'
      preLoaderRoute: typeof ContractsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bills': {
      id: '/bills'
      path: '/bills'
      fullPath: '/bills'
      preLoaderRoute: typeof BillsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sites/': {
      id: '/sites/'
      path: '/'
      fullPath: '/sites/'
      preLoaderRoute: typeof SitesIndexRouteImport
      parentRoute: typeof SitesRouteRoute
    }
    '/site-lists/': {
      id: '/site-lists/'
      path: '/'
      fullPath: '/site-lists/'
      preLoaderRoute: typeof SiteListsIndexRouteImport
      parentRoute: typeof SiteListsRouteRoute
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/contracts/': {
      id: '/contracts/'
      path: '/'
      fullPath: '/contracts/'
      preLoaderRoute: typeof ContractsIndexRouteImport
      parentRoute: typeof ContractsRouteRoute
    }
    '/bills/': {
      id: '/bills/'
      path: '/'
      fullPath: '/bills/'
      preLoaderRoute: typeof BillsIndexRouteImport
      parentRoute: typeof BillsRouteRoute
    }
    '/sites/$siteId': {
      id: '/sites/$siteId'
      path: '/$siteId'
      fullPath: '/sites/$siteId'
      preLoaderRoute: typeof SitesSiteIdRouteImport
      parentRoute: typeof SitesRouteRoute
    }
    '/site-lists/$siteListId': {
      id: '/site-lists/$siteListId'
      path: '/$siteListId'
      fullPath: '/site-lists/$siteListId'
      preLoaderRoute: typeof SiteListsSiteListIdRouteImport
      parentRoute: typeof SiteListsRouteRoute
    }
    '/settings/email-templates': {
      id: '/settings/email-templates'
      path: '/email-templates'
      fullPath: '/settings/email-templates'
      preLoaderRoute: typeof SettingsEmailTemplatesRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/contracts/merge-proposals': {
      id: '/contracts/merge-proposals'
      path: '/merge-proposals'
      fullPath: '/contracts/merge-proposals'
      preLoaderRoute: typeof ContractsMergeProposalsRouteImport
      parentRoute: typeof ContractsRouteRoute
    }
    '/contracts/$contractId': {
      id: '/contracts/$contractId'
      path: '/$contractId'
      fullPath: '/contracts/$contractId'
      preLoaderRoute: typeof ContractsContractIdRouteImport
      parentRoute: typeof ContractsRouteRoute
    }
    '/bills/$billId': {
      id: '/bills/$billId'
      path: '/$billId'
      fullPath: '/bills/$billId'
      preLoaderRoute: typeof BillsBillIdRouteImport
      parentRoute: typeof BillsRouteRoute
    }
  }
}

interface BillsRouteRouteChildren {
  BillsBillIdRoute: typeof BillsBillIdRoute
  BillsIndexRoute: typeof BillsIndexRoute
}

const BillsRouteRouteChildren: BillsRouteRouteChildren = {
  BillsBillIdRoute: BillsBillIdRoute,
  BillsIndexRoute: BillsIndexRoute,
}

const BillsRouteRouteWithChildren = BillsRouteRoute._addFileChildren(
  BillsRouteRouteChildren,
)

interface ContractsRouteRouteChildren {
  ContractsContractIdRoute: typeof ContractsContractIdRoute
  ContractsMergeProposalsRoute: typeof ContractsMergeProposalsRoute
  ContractsIndexRoute: typeof ContractsIndexRoute
}

const ContractsRouteRouteChildren: ContractsRouteRouteChildren = {
  ContractsContractIdRoute: ContractsContractIdRoute,
  ContractsMergeProposalsRoute: ContractsMergeProposalsRoute,
  ContractsIndexRoute: ContractsIndexRoute,
}

const ContractsRouteRouteWithChildren = ContractsRouteRoute._addFileChildren(
  ContractsRouteRouteChildren,
)

interface SettingsRouteRouteChildren {
  SettingsEmailTemplatesRoute: typeof SettingsEmailTemplatesRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteRouteChildren: SettingsRouteRouteChildren = {
  SettingsEmailTemplatesRoute: SettingsEmailTemplatesRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(
  SettingsRouteRouteChildren,
)

interface SiteListsRouteRouteChildren {
  SiteListsSiteListIdRoute: typeof SiteListsSiteListIdRoute
  SiteListsIndexRoute: typeof SiteListsIndexRoute
}

const SiteListsRouteRouteChildren: SiteListsRouteRouteChildren = {
  SiteListsSiteListIdRoute: SiteListsSiteListIdRoute,
  SiteListsIndexRoute: SiteListsIndexRoute,
}

const SiteListsRouteRouteWithChildren = SiteListsRouteRoute._addFileChildren(
  SiteListsRouteRouteChildren,
)

interface SitesRouteRouteChildren {
  SitesSiteIdRoute: typeof SitesSiteIdRoute
  SitesIndexRoute: typeof SitesIndexRoute
}

const SitesRouteRouteChildren: SitesRouteRouteChildren = {
  SitesSiteIdRoute: SitesSiteIdRoute,
  SitesIndexRoute: SitesIndexRoute,
}

const SitesRouteRouteWithChildren = SitesRouteRoute._addFileChildren(
  SitesRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BillsRouteRoute: BillsRouteRouteWithChildren,
  ContractsRouteRoute: ContractsRouteRouteWithChildren,
  SettingsRouteRoute: SettingsRouteRouteWithChildren,
  SiteListsRouteRoute: SiteListsRouteRouteWithChildren,
  SitesRouteRoute: SitesRouteRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
